<template>
  <div class="dynamicalSystemPage">
    <div class="overviewWrap innerW ashComWrap">
      <div class="comTitle">
        <h4>动力系统概览</h4>
        <el-radio-group
          v-model="overviewActive"
          size="mini"
          @input="changeType"
        >
          <el-radio-button
            :label="v.name"
            v-for="v in overviewList"
            :key="v.name"
            >{{ v.name }} {{ v.value }}</el-radio-button
          >
        </el-radio-group>
      </div>
      <div class="comContentBox setFlexBox">
        <div class="box secondAshComWrap">
          <div class="comTitle">
            <h4>运转状态</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'operational'"
              :chartsData="operationalList"
              :type="'pieChart'"
            />
          </div>
        </div>
        <div class="box secondAshComWrap">
          <div class="comTitle">
            <h4>实时功率</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'realTimePower'"
              :chartsData="realTimePowerList"
              :type="'ringChart'"
            />
          </div>
        </div>
        <div class="box1 secondAshComWrap">
          <div class="comTitle">
            <h4>能耗及回馈</h4>
          </div>
          <div class="comContentBox">
            <ul class="overviewUl">
              <li v-for="v in ecList" :key="v.name">
                <p>{{ v.name }}</p>
                <p v-for="(item, index) in v.values" :key="index">
                  {{ item.name }}<span>{{ dealBigNum(item.value) }}</span>
                  {{ item.unit }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="analysisWrap innerW ashComWrap">
      <div class="comTitle">
        <h4>动力系统运行分析</h4>
      </div>
      <div class="comContentBox setFlexBox">
        <div class="box secondAshComWrap">
          <div class="comTitle">
            <h4>近七天运行距离</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              id="'runningDistanceList'"
              :chartsData="runningDistanceList"
              :type="'lightSwitchable'"
            />
          </div>
        </div>
        <div class="box1 secondAshComWrap">
          <div class="comTitle">
            <h4>本月报警分析</h4>
          </div>
          <div class="comContentBox setFlexBox">
            <div class="barBox">
              <PublicEcharts
                id="'alarmBarList'"
                :chartsData="alarmBarList"
                :type="'lightSwitchable'"
              />
            </div>
            <div class="ringBox">
              <PublicEcharts
                :id="'alarmRingList'"
                :chartsData="alarmRingList"
                :type="'ringChart'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tableWrap">
      <div class="alarm">
        <AlarmOrderTable :type="'alarm'" :deviceType="'动力系统'" />
      </div>
      <div class="order">
        <AlarmOrderTable :type="'order'" :deviceType="'动力系统'" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import PublicEcharts from "@/components/PublicEcharts";
import AlarmOrderTable from "@/components/fenxizujian/AlarmOrderTable.vue";
import { dateFtt, dealBigNum, matchingDynamicalState } from "@/assets/js/utils";
export default {
  components: {
    PublicEcharts,
    AlarmOrderTable,
  },
  data() {
    return {
      overviewList: [],
      overviewActive: "",
      operationalList: { dataArr: [] },
      realTimePowerList: { dataArr: [], unit: "" },
      ecList: [],
      runningDistanceList: {
        type: "bar",
        unit: "m",
        showChange: false,
        xData: [],
        dataArr: [],
      }, //运行距离
      alarmRingList: {
        unit: "",
        dataArr: [],
      }, //报警环图
      alarmBarList: {
        type: "bar",
        unit: "次",
        showChange: false,
        xData: [],
        dataArr: [],
      }, //报警柱状图
    };
  },
  methods: {
    dealBigNum,
    changeType() {
      this.getOPERATIONAL();
      this.getRealPower();
      this.getOverviewEC();
    },
    // 概览统计值
    async getDeviceStatistics() {
      this.overviewList = [];
      let res = await api.DynamicalDeviceStatistics({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        let val = res.data.data.reduce(
          (sum, e) => sum + Number(e.value || 0),
          0
        );
        this.overviewList = [{ name: "全部", value: val }].concat(
          res.data.data
        );
        this.overviewActive = this.overviewList[0].name;
        this.getOPERATIONAL();
        this.getRealPower();
        this.getOverviewEC();
      }
    },
    // 概览-运转状态
    async getOPERATIONAL() {
      this.operationalList.dataArr = [];
      let res = await api.DynamicalOPERATIONAL({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.overviewActive == "全部" ? null : this.overviewActive,
      });
      if (res && res.data.code == 200) {
        let obj = { name: "run", value: 0 };
        res.data.data.map((v) => {
          if (v.name == 1 || v.name == 3 || v.name == 4 || v.name == 5) {
            obj.value += Number(v.value);
          }
        });
        let newArr = res.data.data
          .filter((v) => {
            return v.name != 1 && v.name != 3 && v.name != 4 && v.name != 5;
          })
          .concat([obj]);
        this.operationalList.dataArr = Array.from(newArr).map((v) => ({
          name: matchingDynamicalState(v.name),
          value: v.value,
        }));
      }
    },
    // 概览-实时功率
    async getRealPower() {
      this.realTimePowerList.dataArr = [];
      this.realTimePowerList.unit = "";
      let res = await api.DynamicalOverviewRealPower({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.overviewActive == "全部" ? null : this.overviewActive,
      });
      if (res && res.data.code == 200) {
        this.realTimePowerList.unit = res.data.data[0].unit;
        this.realTimePowerList.dataArr = Array.from(res.data.data).map((v) => ({
          name: matchingDynamicalState(v.name),
          value: v.value == "-" ? 0 : v.value,
        }));
      }
    },
    // 概览-能耗及回馈
    async getOverviewEC() {
      this.ecList = [];
      let res = await api.DynamicalOverviewEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.overviewActive == "全部" ? null : this.overviewActive,
      });
      if (res && res.data.code == 200) {
        this.ecList = res.data.data;
      }
    },

    async getRunningDistance() {
      this.runningDistanceList.xData = [];
      this.runningDistanceList.dataArr = [];
      let res = await api.DynamicalOverviewRunningDistance({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceTypes: "直梯,扶梯,加速带",
      });
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.map((v) => {
          this.runningDistanceList.xData.push(dateFtt("dd日", new Date(v.ts)));
          arr.push(v.values);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.runningDistanceList.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.runningDistanceList.dataArr[i].name = item[i].name;
            this.runningDistanceList.dataArr[i].data.push(item[i].value);
          });
        }
      }
    },
    async getAlarmAnalysis() {
      this.alarmBarList.xData = [];
      this.alarmBarList.dataArr = [{ name: "报警趋势", data: [] }];
      let res = await api.getSAlarmRangeTrend({
        type: "MONTH",
        data: dateFtt("yyyy-MM", new Date()),
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        assetType: "动力系统",
      });
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this.alarmBarList.xData.push(dateFtt("dd日", new Date(v.ts)));
          this.alarmBarList.dataArr[0].data.push(v.value);
        });
      }
    },
    async getAlarmReason() {
      this.alarmRingList.dataArr = [];
      let res = await api.DynamicalOverviewAlarmReason({
        type: "MONTH",
        data: dateFtt("yyyy-MM", new Date()),
        entityId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.alarmRingList.dataArr = res.data.data;
      }
    },
  },
  created() {
    this.getDeviceStatistics();
    this.getRunningDistance();
    this.getAlarmAnalysis();
    this.getAlarmReason();
  },
};
</script>

<style lang="scss" scoped>
.dynamicalSystemPage {
  width: 100%;
  overflow: auto;
  .innerW {
    width: $innerWidth;
    margin: 0 auto;
  }
  .setFlexBox {
    @include setFlexAround;
  }
  .overviewWrap {
    height: 300px;
    margin: 16px auto 12px;
    .box {
      width: 28%;
      height: 100%;
    }
    .box1 {
      width: 40%;
      height: 100%;
    }
    .overviewUl {
      width: 100%;
      height: 100%;
      @include setFlexColumn;
      justify-content: space-around;
      li {
        width: 100%;
        height: 30%;
        @include setFlexBetween;
        p {
          width: 28%;
          span {
            font-size: 16px;
            font-weight: bold;
            margin: 0 10px;
          }
        }
        p:nth-child(1) {
          width: 12%;
          text-align: center;
        }
      }
    }
  }
  .analysisWrap {
    height: 300px;
    .box {
      width: 30%;
      height: 100%;
    }
    .box1 {
      width: 65%;
      height: 100%;
      .barBox {
        width: 55%;
        height: 100%;
      }
      .ringBox {
        width: 43%;
        height: 100%;
      }
    }
  }
  .tableWrap {
    width: $innerWidth;
    height: 500px;
    margin: 12px auto 16px;
    @include setFlexBetween;
    .alarm,
    .order {
      width: $halfWidth;
      height: 100%;
    }
  }
}
</style>
